import { useCallback, useMemo, useRef } from 'react';
import React from 'react';
import { Provider } from 'urql';

import type { UrqlErrorHandler } from './UrqlContext';
import { UrqlContext } from './UrqlContext';
import { useUrqlClient } from './useUrqlClient';

export const UrqlProvider = (props: Props) => {
  const errorHandlerReference = useRef<UrqlErrorHandler>(() => {});
  const client = useUrqlClient(errorHandlerReference);

  const registerUrqlErrorTracker = useCallback(
    (trackUrqlError: UrqlErrorHandler) => {
      // eslint-disable-next-line functional/immutable-data
      errorHandlerReference.current = trackUrqlError;
    },
    [errorHandlerReference],
  );

  const value = useMemo(
    () => ({ registerUrqlErrorTracker }),
    [registerUrqlErrorTracker],
  );

  if (!client) return null; // avoids TS error from pre-init `null` state

  return (
    <UrqlContext.Provider value={value}>
      <Provider value={client}>{props.children}</Provider>
    </UrqlContext.Provider>
  );
};

type Props = Readonly<{ children: React.ReactNode }>;
